import { SpoofBanner } from '@studio/navigation';
import { useAuth } from 'studio5/contexts';

const SpoofBannerProvider = () => {
  const { accountId, isSpoofing, despoof } = useAuth();

  return (
    <SpoofBanner
      accountId={accountId}
      spoofing={isSpoofing}
      onDespoof={despoof}
    />
  );
};

export default SpoofBannerProvider;
